/**
 * Языковые константы. Файл намеренно без зависимостей от браузера —
 * его импортирует и клиент, и прокси (Node) для параметра `Language`.
 */
export type Language = 'uz' | 'ru' | 'en'

/**
 * Язык до того, как клиент выбрал свой. Узбекский: бренд работает в
 * Узбекистане, и первым экраном человек должен видеть свой язык, а не тот,
 * на котором ему удобнее переписываться в мессенджере.
 *
 * Эта же константа — запасной язык для прокси: он подставляет её в параметр
 * `Language`, когда клиент не прислал заголовок.
 */
export const DEFAULT_LANGUAGE: Language = 'uz'

/** Числовые коды языка для бэкенда — уходят параметром `Language` в каждом запросе. */
export const LANGUAGE_CODE: Record<Language, number> = {
  uz: 1,
  ru: 2,
  en: 3,
}

/** Имя как в веб-версии: его же ставит @nuxtjs/i18n и читает прокси. */
export const LANGUAGE_COOKIE = 'i18n_redirected'
